import styled from 'styled-components';
import convertHexToRgba from 'utils/convertHexToRgba';

const Indicator = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  padding: 0;
  border: 3px solid transparent;
  width: ${({ theme }) => theme.space.xl};
  height: ${({ theme }) => theme.space.xl};
  background: ${({ theme }) => convertHexToRgba(theme.colors.indicator.default, 0.8)};
  box-shadow: ${({ theme }) => theme.boxShadow.elevated};
  outline-offset: 4px;
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  &::after {
    content: '';
    border-radius: 50%;
    border: 6px solid transparent;
    background: ${({ theme }) => theme.colors.white};
    z-index: 2;
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  &:hover {
    &::after {
      transform: scale(0.667);
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.feedback.focus};
  }
`;

export default Indicator;
